import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=73ea1ed9&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ea1ed9')) {
      api.createRecord('73ea1ed9', component.options)
    } else {
      api.reload('73ea1ed9', component.options)
    }
    module.hot.accept("./QRCode.vue?vue&type=template&id=73ea1ed9&", function () {
      api.rerender('73ea1ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/QRCode.vue"
export default component.exports